import { Button, Flex, Menu, IconButton, MenuButton, MenuItem, MenuList, Icon } from '@chakra-ui/react';
import { useTranslation } from 'helpers/languages/translations';
import { FC } from 'react';
import { iconTableStyle, tableToolbarStyle } from 'shared/styles';
import { TKeywordsByRetailers } from './useKeywordsByRetailers';
import icons from 'shared/icons';

interface ICategoriesToolbarProps {
    handleEditRetailers: () => void;
    isDisabled: boolean;
    handleExportKeywordsByRetailer: TKeywordsByRetailers['handleExportKeywordsByRetailer'];
    isExportLoading: boolean;
    isFetching: boolean;
}

const CategoriesToolbar: FC<ICategoriesToolbarProps> = ({
    handleEditRetailers,
    isDisabled,
    handleExportKeywordsByRetailer,
    isExportLoading,
    isFetching,
}) => {
    const DownloadIcon = icons.download;
    const translate = useTranslation();
    return (
        <Flex {...tableToolbarStyle}>
            <Button
                {...iconTableStyle}
                aria-label="Associate Keywords"
                size="sm"
                onClick={handleEditRetailers}
                isDisabled={isDisabled}
            >
                {translate('categories_keywords.column.associate_keywords')}
            </Button>


            <Menu>
                <MenuButton
                    as={IconButton}
                    {...iconTableStyle}
                    isDisabled={isExportLoading || isFetching}
                    aria-label="download excel"
                    isLoading={isExportLoading || isFetching}
                    size="sm"
                    icon={<Icon as={DownloadIcon} />}
                />
                <MenuList zIndex="modal">
                    <MenuItem onClick={
                        () =>
                            handleExportKeywordsByRetailer(false)
                    }>
                        {translate('keywords_by_retailer.download')}
                    </MenuItem>
                    <MenuItem onClick={
                        () =>
                            handleExportKeywordsByRetailer(true)
                    }>
                        {translate('keywords_by_retailer.download.with_weights')}
                    </MenuItem>
                </MenuList>
            </Menu>

        </Flex >
    );
};

export default CategoriesToolbar;
